import React, {FC, PropsWithChildren, ReactNode} from "react";
import "./ui.css";

type KpiCardProps = {
    value: ReactNode;
    label: ReactNode;
    hint?: ReactNode;
};

export const KpiCard: FC<KpiCardProps> = ({value, label, hint}) => (
    <article className="ati-kpi">
        <span className="ati-kpi__value">{value}</span>
        <span className="ati-kpi__label">{label}</span>
        {hint ? <span className="ati-kpi__hint">{hint}</span> : null}
    </article>
);

export const KpiGrid: FC<PropsWithChildren<{"aria-label"?: string}>> = ({children, ...rest}) => (
    <section className="ati-kpi-grid" aria-label={rest["aria-label"]}>{children}</section>
);
